import { render, staticRenderFns } from "./ClientName.vue?vue&type=template&id=787c957d"
import script from "./ClientName.vue?vue&type=script&lang=ts"
export * from "./ClientName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports